import {
  Add_Comment,
  Delete_All_Action_For_One_Lead,
  Get_All_Selected_User_Comments,
  Get_Error,
  Get_Last_200_Comment_For_Admin_Dashboard,
  GetAllActionsDataDashboardType,
  GetAllActionsType,
  Insert_Comment_Replay,
  Update_Selected_Comment,
} from '../Types';

const intial = {
  Action: [],
  AddAction: [],
  insrertrepaly: [],
  onseuseraction: [],
  loading: true,
};

const ActionReducers = (state = intial, action) => {
  switch (action.type) {
    case GetAllActionsType:
      return {
        ...state,
        Action: action.payload,
        loading: false,
      };
    case Add_Comment:
      return {
        ...state,
        AddAction: action.payload,
        loading: false,
      };
    case GetAllActionsDataDashboardType:
      return {
        ...state,
        Action: action.payload,
        loading: false,
      };

    case Delete_All_Action_For_One_Lead:
      return {
        ...state,
        Action: action.payload,
        loading: false,
      };
    case Insert_Comment_Replay:
      return {
        ...state,
        insrertrepaly: action.payload,
        loading: false,
      };
    case Get_All_Selected_User_Comments:
      return {
        ...state,
        onseuseraction: action.payload,
        loading: false,
      };
    case Update_Selected_Comment:
      return {
        ...state,
        Action: action.payload, // أو حسب شكل الريسبونس
      };

    case Get_Last_200_Comment_For_Admin_Dashboard:
      return {
        ...state,
        Action: action.payload, // أو حسب شكل الريسبونس
      };

    case Get_Error:
      return {
        loading: true,
        city: action.payload,
      };
    default:
      return state;
  }
};

export default ActionReducers;
